export const PACKAGE_PREFIX = 'universal-create';
export const TRIGGER_BUTTON_TEST_ID: 'universal-create-trigger-button' = `${PACKAGE_PREFIX}-trigger-button`;
export const ANALYTICS_CHANNEL = 'navigation';
export const MAX_ALLOWED_SECTIONS = 3;
export const SOURCE_LOCATION = 'universal-create';
export const REQUIRED_USER_ITEMS: string[] = [
	'ati:cloud:townsquare:team',
	'ati:cloud:townsquare:goal',
];

export const MAX_MENU_HEIGHT = 430;

// Leaves room for the gaps between rows in the simplified menu styling.
export const SIMPLIFIED_MAX_MENU_HEIGHT = 460;

export const RESPONSIVE_BREAKPOINT = 'sm';

/**
 * Max viewport width (in px) at which the universal create menu switches to its
 * responsive/mobile layout. Matches the `sm` design-system breakpoint upper bound.
 */
export const MOBILE_WIDTH_BREAKPOINT = 767;

/**
 * Debounce interval (in ms) for the window `resize` listener used by `useIsResponsiveView`.
 */
export const RESIZING_DEBOUNCED = 100;

/**
 * Sentinel index for the primary action item injected on mobile viewports.
 * Uses -1 to avoid colliding with the 0-based indices of regular section items.
 */
export const PRIMARY_ACTION_ITEM_INDEX = -1;
